
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { formatDate } from "@/core/helpers/DatetimeConverter";

import ApiService from "@/core/services/ApiService";
import { Endpoints } from "@/api/ApiEndpoints";
import Messages from "@/core/helpers/Messages";
import { useStore } from "vuex";

export default defineComponent({
  name: "UserActivityPage",
  setup() {
    const route = useRoute();
    const store = useStore();
    const activities = ref<Array<Record<string, any>>>([]);
    const loading = ref(false);
    const routeKey = "";

    const userId = computed(() => route.params.id as string);

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    const renderAmount = (value: unknown) => {
      if (value === null || value === undefined || value === "") return "-";
      if (typeof value === "number") return value.toLocaleString();
      return value;
    };

    const formatActivityDate = (value: string) => {
      if (!value) return "-";
      return formatDate(value);
    };

    const parseAmount = (value: unknown) => {
      if (typeof value === "number") return value;
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return null;
        const parsed = Number(trimmed.replace(/,/g, ""));
        return Number.isFinite(parsed) ? parsed : null;
      }
      return null;
    };

    const getActivityIcon = (activity: Record<string, any>) => {
      switch (activity.type) {
        case "CouponCreated":
          return "bi bi-ticket-perforated";
        case "CouponLiked":
          return "bi bi-heart";
        case "WinningAddition":
          return "bi bi-trophy";
        case "Transaction":
          return "bi bi-arrow-left-right";
        default:
          return "bi bi-clock-history";
      }
    };

    const buildActivityText = (activity: Record<string, any>) => {
      console.log(activity);
      const couponId = activity.couponId ? `#${activity.couponId}` : "#-";
      const couponForLinkId = activity.couponId ? `${activity.couponId}` : "#-";
      const amount = renderAmount(activity.amount);
      const txId = activity.transactionId ? `#${activity.transactionId}` : "#-";
      const txType = activity.transactionType || "Transaction";
      const txStatus = activity.transactionStatus || "Unknown";
      const missionId = activity.missionId ? `#${activity.missionId}` : "#-";
      const missionForLinkId = activity.missionId ? `${activity.missionId}` : "-";
      const targetUserId = activity.targetUserId ? `#${activity.targetUserId}` : "#-";
      const targetUserForLinkId = activity.targetUserId ? `${activity.targetUserId}` : "-";
     

      switch (activity.type) {
        case "CouponCreated":
          return `Coupon created <a href="/coupons/list?pageNumber=1&SearchTerm=${couponForLinkId}">${couponId}</a> with ${amount} coins.`;
        case "CouponLiked":
          return `Coupon liked <a href="/coupons/list?pageNumber=1&SearchTerm=${couponForLinkId}/>${couponId}</a>.`;
        case "WinningAddition":
          return `Won ${amount} coins from coupon <a href="/coupons/list?pageNumber=1&SearchTerm=${couponForLinkId}/>${couponId}</a>.`;
        case "Transaction":{
          if(txType == "MissionCompleted"){
            return `<b>Mission ${missionId}</b> completed and earn <b>${amount} coins</b> .`;
          }
          else if(txType=="WinningAddition"){
            return `Get <b>${amount} coins </b>for coupon won <a href="/coupons/list?pageNumber=1&SearchTerm=${couponForLinkId}">${couponId}</a>  .`;
          }
          else{
            return `${txType} transaction ${txId} (${txStatus}) for <b>${amount} coins</b> .`;
          }
        }
        case "MissionCompleted":
          return `Mission completed ${missionId}.`;
        case "UserFollowed":
          return `Followed user <a href="/users/list?pageNumber=1&SearchTerm=${targetUserForLinkId}">${targetUserId}</a>.`;
        case "UserCreated":
          return `User Created with balnace ${amount} coins`;
        default:
          return `${activity.type || "Activity"} ${couponId} ${amount !== "-" ? `with ${amount} coins` : ""}`;
      }
    };

    const fetchActivity = async () => {
      if (!userId.value) return;
      loading.value = true;
      try {
        const response = await ApiService.get(
          `${Endpoints.USERS}/${userId.value}/activity`,
          ""
        );
        activities.value = Array.isArray(response?.data) ? response.data : [];
      } catch (error: any) {
        Messages.showError(
          error?.response?.data?.errors ?? { Error: ["Failed to load activity."] }
        );
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      
      fetchActivity();
    });

    watch(
      () => route.params.id,
      () => {
        fetchActivity();
      }
    );

    const displayActivities = computed(() => {
      let balance = 0;
      const reversed = (activities.value || []).slice().reverse();
      const withBalances = reversed.map((activity) => {
        const amount = parseAmount(activity?.amount);
        console.log(1111);
        console.log(activity);
        console.log(amount);
        console.log(4444);
        if (amount !== null) {
          if (activity.type === "CouponCreated") {
            balance -= Math.abs(amount);
          } else {
            balance += amount;
          }
          return { ...activity, coinBalance: balance };
        }
        return { ...activity };
      });
      return withBalances.reverse();
    });

    return {
      activities,
      displayActivities,
      loading,
      userId,
      breadcrumbs,
      renderAmount,
      formatActivityDate,
      getActivityIcon,
      buildActivityText,
      routeKey,
    };
  },
});
